import {AuthModel} from '../models/auth/AuthModel';
import {BikesListModel} from '../models/bikes/BikesListModel';
import {MobileUserAccountsListModel} from '../models/mobileUserAccounts/MobileUserAccountsListModel';
import {TenantsListModel} from '../models/tenants/TenantsListModel';
import {WithdrawalModel} from "../models/WithdrawalModel";
import {TableModel} from "../models/TableModel";

export default {
  auth: new AuthModel(null),
  notifications: [],
  bikes: {
    list: new BikesListModel(),
  },
  zones: {
    importing: false
  },
  virtualLocks: {
    data: [],
    fetching: false,
  },
  virtualLocksExternalTester: {
    data: [],
    fetching: false,
    isLogin: false,
    logging: false,
    token: null,
  },
  bikeTypes: {
    data: [],
    fetching: false,
  },
  bikeParts: {
    data: [],
    fetching: false,
  },
  externalOffer: {
    pagedData: new TableModel(
      {pageNumber: 1, pageSize: 100},
      [{id: 'createdAt', value: 'desc'}],
    ),
    fetching: false,
  },
  mobileUserAccounts: {
    list: new MobileUserAccountsListModel(),
  },
  mobileUserAccountDetails: {
    data: null,
    fetching: true,
  },
  tenants: {
    list: new TenantsListModel(),
  },
  tenantDetails: {
    data: null,
    fetching: true,
  },
  reports: {
    templateList: [],
    fetchingTemplateList: true,
    submitting: false,
    reportConfigurationList: [],
    fetchingReportConfigurationList: true,
    reportConfigurationHistory: null,
    fetchingReportConfigurationHistory: true,
    fetchingWithdrawalReport: false,
    withdrawalsData: new WithdrawalModel(),
    changeWithdrawalStatusSubmitting: false,
  },
  publicAccessToken: {
    showNewTokenDialog: false,
    showCreatedTokenDialog: false,
    accessToken: null,
    accessTokenList: [],
    fetchingAccessTokenList: true,
    submitting: false,
    permissions: [],
    fetchingPermissions: false,
    tokenDialog: {
      show: false,
      edit: false,
      data: null
    },
    deactivateTokenDialog: {
      show: false,
      data: null
    }
  }
};
